import { useEffect, useState, useRef, useMemo } from "react";
import { useSelector } from "react-redux";

import { getApi } from "../../api/api";
import { useSearch } from "../../common/components/search/useSearch";
import { selectClusterList } from "../../store/slices/clusterListSlice";
import { SaleItemInterface } from "../../common/types/interfaces";
import { useMainSearch } from "./useMainSearch";
import { useCityId } from "../../common/hooks/useCityId";

export const useMain = () => {
  const clusters = useSelector(selectClusterList);
 const cityId = useCityId()

  const { query, setQuery, clearSearch, isDebouncing } = useSearch(600, false);
  const { categories, items, isFetching } = useMainSearch(query, isDebouncing);

  const [bannerItems, setBannerItems] = useState<SaleItemInterface[]>([]);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const idleTimerRef = useRef<NodeJS.Timeout | null>(null);

  // Загрузка баннера (с cityId)
  useEffect(() => {
    let cancelled = false;
    getApi()
      .getBannerItems(20, cityId)
      .then((data) => {
        if (!cancelled) setBannerItems(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [cityId]);

  // Логика переключения режимов с задержкой
  useEffect(() => {
    if (query.trim()) {
      setIsSearchMode(true);
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    } else {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      idleTimerRef.current = setTimeout(() => {
        setIsSearchMode(false);
      }, 3000);
    }

    return () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    };
  }, [query]);

  // Уникальные типы бизнеса из кластеров
  const clusterTypes = useMemo(() => {
    const set = new Set<number>();
    clusters.forEach((c) => {
      if (typeof c.type === "number") set.add(c.type);
    });
    return Array.from(set).sort((a, b) => a - b);
  }, [clusters]);

  const isBusy = isFetching || isDebouncing;

  return {
    clusters,
    query,
    setQuery,
    clearSearch,
    isDebouncing,
    categories,
    items,
    bannerItems,
    isSearchMode,
    isBusy,
    clusterTypes,
  };
};
